import service from "../service";

export const getTasksService = (data) => (
  service('post', `v3/tareas/`, { data })
)
export const getPendingTasksService = () => (
  service('get', `v3/tareas/pendientes`)
)
export const getAclaracionesService = (data) => (
  service('post', `v3/aclaraciones/`, { data })
)
export const createAclaracionService = (data) => (
  service('put', `v3/aclaraciones/`, { data })
)
export const updateTaskService = (taskId, data) => (
  service('patch', `v3/tareas/${taskId}`, { data })
)

export const deleteTaskService = (taskId, data) => (
  service('delete', `v3/tareas/${taskId}`, { data })
)


